import { cn } from "@/lib/utils";

/**
 * TripMuscle · FareCheck brand lockup.
 * Dumbbell "muscle" mark + TripMuscle wordmark (Muscle carries the weight)
 * + FareCheck module pill. Matches docs/mockups/fare-matrix.html.
 */
interface BrandLockupProps {
  /** Show the "FareCheck" module pill (default true). */
  showModule?: boolean;
  /** Optional tagline shown on wider viewports. */
  tagline?: string;
  className?: string;
}

/** Lucide-style dumbbell, stroked — the TripMuscle mark. */
function DumbbellMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
    >
      <line x1="3" y1="9" x2="3" y2="15" />
      <line x1="6.5" y1="6.5" x2="6.5" y2="17.5" />
      <line x1="6.5" y1="12" x2="17.5" y2="12" />
      <line x1="17.5" y1="6.5" x2="17.5" y2="17.5" />
      <line x1="21" y1="9" x2="21" y2="15" />
    </svg>
  );
}

export default function BrandLockup({ showModule = true, tagline, className }: BrandLockupProps) {
  return (
    <span className={cn("brand-mark inline-flex items-center gap-2 text-ink", className)}>
      <DumbbellMark className="h-5 w-5 flex-none text-primary" />
      <span className="font-mono text-[15px] font-bold tracking-tight">
        Trip<span className="font-extrabold">Muscle</span>
      </span>
      {showModule && (
        <span className="ml-0.5 rounded-full border border-primary/25 bg-primary/10 px-2 py-0.5 font-mono text-[10.5px] font-semibold uppercase tracking-wide text-teal-700">
          FareCheck
        </span>
      )}
      {tagline && (
        <span className="ml-1 hidden text-xs font-normal text-muted-foreground sm:inline">{tagline}</span>
      )}
    </span>
  );
}
